import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

export const dbUserGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.dbUser$.pipe(
    map((user) => {
      if (user) {
        return true;
      } else {
        void router.navigate(['']);
        return false;
      }
    }),
  );
};
